import { SVGProps } from 'react';

const TransactionIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      width="88"
      height="88"
      viewBox="0 0 88 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1790_7438)">
        <path
          d="M81 19H7C3.13401 19 0 22.134 0 26V61.9C0 65.766 3.13401 68.9 7 68.9H81C84.866 68.9 88 65.766 88 61.9V26C88 22.134 84.866 19 81 19Z"
          fill="#F9DA91"
        />
        <path
          d="M80.2998 51.3984H49.7998C49.2475 51.3984 48.7998 51.8462 48.7998 52.3984V55.2984C48.7998 55.8507 49.2475 56.2984 49.7998 56.2984H80.2998C80.8521 56.2984 81.2998 55.8507 81.2998 55.2984V52.3984C81.2998 51.8462 80.8521 51.3984 80.2998 51.3984Z"
          fill="white"
        />
        <path
          d="M73.0998 58.5H49.7998C49.2475 58.5 48.7998 58.9477 48.7998 59.5V62.4C48.7998 62.9523 49.2475 63.4 49.7998 63.4H73.0998C73.6521 63.4 74.0998 62.9523 74.0998 62.4V59.5C74.0998 58.9477 73.6521 58.5 73.0998 58.5Z"
          fill="white"
        />
        <path d="M26.5008 19H23.3008V68.9H26.5008V19Z" fill="#E2B857" />
        <path d="M88 44.7V41.5L0 41.5V44.7L88 44.7Z" fill="#E2B857" />
        <path
          d="M26.6735 47.3278L22.5723 43.2266L14.9355 50.8633L19.0367 54.9645L26.6735 47.3278Z"
          fill="#E2B857"
        />
        <path
          d="M30.7728 54.9137L34.874 50.8125L27.2373 43.1757L23.1361 47.277L30.7728 54.9137Z"
          fill="#E2B857"
        />
        <path
          d="M15.4992 27C11.1914 27 7.69922 30.4922 7.69922 34.8C7.69922 39.1078 11.1914 42.6 15.4992 42.6H23.2992V34.8C23.2992 30.4922 19.807 27 15.4992 27ZM21.8992 41.3H17.8992C15.6901 41.3 13.8992 39.5091 13.8992 37.3C13.8992 35.0909 15.6901 33.3 17.8992 33.3C20.1084 33.3 21.8992 35.0909 21.8992 37.3V41.3Z"
          fill="#E2B857"
        />
        <path
          d="M34.3 27C29.9922 27 26.5 30.4922 26.5 34.8V42.6H34.3C38.6078 42.6 42.1 39.1078 42.1 34.8C42.1 30.4922 38.6078 27 34.3 27ZM27.9 37.3C27.9 35.0909 29.6909 33.3 31.9 33.3C34.1091 33.3 35.9 35.0909 35.9 37.3C35.9 39.5091 34.1091 41.3 31.9 41.3H27.9V37.3Z"
          fill="#E2B857"
        />
        <path d="M25.5008 19H22.3008V68.9H25.5008V19Z" fill="#E07E16" />
        <path d="M88 43.7V40.5L0 40.5V43.7L88 43.7Z" fill="#E07E16" />
        <path
          d="M25.6735 46.3278L21.5723 42.2266L13.9355 49.8633L18.0367 53.9645L25.6735 46.3278Z"
          fill="#E07E16"
        />
        <path
          d="M29.7728 53.9137L33.874 49.8125L26.2373 42.1757L22.1361 46.277L29.7728 53.9137Z"
          fill="#E07E16"
        />
        <path
          d="M14.4992 25C10.1914 25 6.69922 28.4922 6.69922 32.8C6.69922 37.1078 10.1914 40.6 14.4992 40.6H22.2992V32.8C22.2992 28.4922 18.807 25 14.4992 25ZM20.8992 39.3H16.8992C14.6901 39.3 12.8992 37.5091 12.8992 35.3C12.8992 33.0909 14.6901 31.3 16.8992 31.3C19.1084 31.3 20.8992 33.0909 20.8992 35.3V39.3Z"
          fill="#E07E16"
        />
        <path
          d="M33.3 25C28.9922 25 25.5 28.4922 25.5 32.8V40.6H33.3C37.6078 40.6 41.1 37.1078 41.1 32.8C41.1 28.4922 37.6078 25 33.3 25ZM26.9 35.3C26.9 33.0909 28.6909 31.3 30.9 31.3C33.1091 31.3 34.9 33.0909 34.9 35.3C34.9 37.5091 33.1091 39.3 30.9 39.3H26.9V35.3Z"
          fill="#E07E16"
        />
        <path
          d="M64 8.1C64 6.99543 63.1046 6.1 62 6.1H11.6V1.93152C11.6 1.12039 10.6851 0.64673 10.0228 1.11494L1.14817 7.38836C0.586461 7.78543 0.584078 8.61792 1.14351 9.0182L10.0181 15.3681C10.6799 15.8416 11.6 15.3686 11.6 14.5549V10.4H62C63.1046 10.4 64 9.50457 64 8.4V8.1Z"
          fill="#26AA68"
        />
        <path
          d="M24 79.9C24 81.0046 24.8954 81.9 26 81.9H76.4V86.0685C76.4 86.8796 77.3149 87.3533 77.9772 86.8851L86.8518 80.6116C87.4135 80.2146 87.4159 79.3821 86.8565 78.9818L77.9819 72.6319C77.3201 72.1584 76.4 72.6314 76.4 73.4451V77.6H26C24.8954 77.6 24 78.4954 24 79.6V79.9Z"
          fill="#E07E16"
        />
      </g>
      <defs>
        <clipPath id="clip0_1790_7438">
          <rect width="88" height="88" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TransactionIcon;
